import gql from "graphql-tag";
import { fragments as documentFragments } from "/imports/api/documents/apollo/fragments";

const invoiceItemCost = gql`
  fragment invoiceItemCost on InvoiceItemCost {
    id
    costId
    description
    amount {
      value
      currency
      rate
    }
    tax

    # projected:
    orgIndex
  }
`;

export const fragments = {
  invoiceBase: gql`
    fragment invoiceBase on Invoice {
      id
      clientId
      creatorId
      sellerId
      status
      date
      number
      amount {
        value
        currency
      }
      tax {
        value
        currency
      }
      gross {
        value
        currency
      }
      delta {
        value
        currency
      }
      calculated {
        value
        currency
      }
      costs {
        code
        description
        costId
      }
    }
  `,
  invoiceDocuments: gql`
    fragment invoiceDocuments on Invoice {
      documents {
        ...documentMinimal
      }
    }
    ${documentFragments.documentMinimal}
  `,
  invoicePartner: gql`
    fragment invoicePartner on InvoicePartnerType {
      id
      name
      entityCode
      entityName
      address
      zip
      city
      country
      vat
    }
  `,
  invoiceItem: gql`
    fragment invoiceItem on InvoiceItem {
      id
      shipmentId
      number
      references
      itemNet
      itemTax
      itemGross
      otherInvoice
      calculated
      delta
      calcCurrency
      exchangeRates
    }
  `,
  invoiceItemCost,
  invoiceItemWithCost: gql`
    fragment invoiceItemWithCost on InvoiceItem {
      id
      invoiceId
      costs {
        ...invoiceItemCost
      }
    }
    ${invoiceItemCost}
  `,
  invoiceTotals: gql`
    fragment invoiceTotals on Invoice {
      totals {
        dateMismatch
        invHasCostCount
        shipHasCostCount
        largeDeltaCount
        shipCount
        shipment {
          base
          fuel
          total
        }
        invoice {
          base
          fuel
          total
        }
        delta
      }
    }
  `,
  invoiceUpdates: gql`
    fragment invoiceUpdates on Invoice {
      updates {
        action
        ts
        userId
        data
      }
    }
  `,
  invoiceAudits: gql`
    fragment invoiceAudits on Invoice {
      audits {
        ts
        isCleared
        checks {
          invoiceItemsNotInShipment
          shipmentCostsNotApproved
          deltaOk
          hasItems
        }
      }
    }
  `,
  invoiceWithItems: null
};

fragments.invoiceWithItems = gql`
  fragment invoiceWithItems on Invoice {
    ...invoiceBase
    ...invoiceDocuments
    seller {
      ...invoicePartner
    }
    client {
      ...invoicePartner
    }
    itemCount
    acceptance {
      accepted
      at
      reason
      by
      notes
    }
    currency
    edi
    items {
      ...invoiceItem
    }
    ...invoiceTotals
    ...invoiceUpdates
  }
  ${fragments.invoiceBase}
  ${fragments.invoiceDocuments}
  ${fragments.invoicePartner}
  ${fragments.invoiceItem}
  ${fragments.invoiceTotals}
  ${fragments.invoiceUpdates}
`;
